import React from 'react';
export function DemoPage() {
  return <div className="pt-32 pb-20" data-id="element-6060">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16" data-id="element-6061">
        <div data-id="element-6062">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-6063">
            See Booker on your workflow.
          </h1>
          <p className="text-lg text-textMuted mb-8" data-id="element-6064">
            Book a 30-minute walkthrough with our team. We'll show you how
            Booker can streamline your specific routing, negotiation, and
            contract processes.
          </p>

          <div className="space-y-6" data-id="element-6065">
            <div className="bg-surface border border-border rounded-xl p-6" data-id="element-6066">
              <h3 className="font-semibold mb-2" data-id="element-6067">What you'll see:</h3>
              <ul className="space-y-2 text-sm text-textMuted" data-id="element-6068">
                <li data-id="element-6069">
                  • Live demonstration of route planning and venue discovery
                </li>
                <li data-id="element-6070">
                  • How the AI assistant drafts outreach and analyzes offers
                </li>
                <li data-id="element-6071">• The contract generation and deposit tracking workflow</li>
                <li data-id="element-6072">• Q&A specific to your roster or venue</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-surface border border-border rounded-2xl p-8" data-id="element-6073">
          <form className="space-y-4" data-id="element-6074">
            <div className="grid grid-cols-2 gap-4" data-id="element-6075">
              <div data-id="element-6076">
                <label className="block text-sm font-medium mb-2" data-id="element-6077">
                  First Name
                </label>
                <input type="text" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6078" />
              </div>
              <div data-id="element-6079">
                <label className="block text-sm font-medium mb-2" data-id="element-6080">
                  Last Name
                </label>
                <input type="text" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6081" />
              </div>
            </div>
            <div data-id="element-6082">
              <label className="block text-sm font-medium mb-2" data-id="element-6083">
                Work Email
              </label>
              <input type="email" className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6084" />
            </div>
            <div data-id="element-6085">
              <label className="block text-sm font-medium mb-2" data-id="element-6086">
                I am a...
              </label>
              <select className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-6087">
                <option data-id="element-6088">Touring Artist / Band</option>
                <option data-id="element-6089">Booking Agent / Manager</option>
                <option data-id="element-6090">Venue / Promoter</option>
              </select>
            </div>
            <div data-id="element-6091">
              <label className="block text-sm font-medium mb-2" data-id="element-6092">
                Anything specific you want to see?
              </label>
              <textarea rows={3} className="w-full px-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary resize-none" data-id="element-6093"></textarea>
            </div>
            <button type="button" className="w-full py-3 bg-primary text-background rounded-lg font-medium hover:bg-primaryHover transition-colors mt-4" data-id="element-6094">
              Request Demo
            </button>
          </form>
        </div>
      </div>
    </div>;
}